var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('div',[_c('div',{staticClass:"card",staticStyle:{"padding":"20px"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.rawHTML)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }